import { useEffect, useRef } from 'react';

const steps = [
  {
    number: '01',
    image: 'https://readdy.ai/api/search-image?query=Person%20browsing%20custom%20house%20number%20products%20on%20a%20modern%20laptop%20screen%2C%20elegant%20website%20with%20product%20showcase%2C%20cozy%20home%20office%20desk%20with%20warm%20natural%20lighting%2C%20professional%20lifestyle%20photography%20with%20soft%20shadows%20and%20clean%20composition%2C%20online%20shopping%20experience&width=600&height=400&seq=process-1-2026&orientation=landscape',
    title: 'Odaberi proizvod',
    description: 'Izaberi kućni broj, pločicu za vrata ili oznaku. Izaberi oblik, boju i veličinu po svojoj želji.',
  },
  {
    number: '02',
    image: 'https://readdy.ai/api/search-image?query=Designer%20working%20on%20a%20custom%20house%20number%20design%20on%20a%20tablet%2C%20personalized%20typography%20and%20shapes%20on%20screen%2C%20modern%20workspace%20with%20warm%20ambient%20lighting%2C%20professional%20creative%20photography%20with%20soft%20shadows%20and%20clean%20minimal%20composition%2C%20digital%20design%20process&width=600&height=400&seq=process-2-2026&orientation=landscape',
    title: 'Personalizuj dizajn',
    description: 'Unesi tekst, broj ili ime. Mi ti šaljemo vizuelni prikaz pre izrade. Zatraži izmene besplatno.',
  },
  {
    number: '03',
    image: 'https://readdy.ai/api/search-image?query=Premium%20house%20number%20package%20being%20delivered%20to%20a%20beautiful%20modern%20home%20entrance%2C%20happy%20moment%20of%20receiving%20a%20personalized%20product%2C%20warm%20golden%20hour%20lighting%2C%20professional%20lifestyle%20photography%20with%20soft%20shadows%20and%20clean%20composition%2C%20delivery%20satisfaction&width=600&height=400&seq=process-3-2026&orientation=landscape',
    title: 'Poruči i primi',
    description: 'Potvrdi porudžbinu. Proizvod izrađujemo za 1 dan i šaljemo brzom poštom. Dostava 2-4 dana.',
  },
];

export default function ProcessSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const els = entry.target.querySelectorAll('.reveal');
            els.forEach((el, i) => {
              setTimeout(() => {
                el.classList.add('animate-in');
              }, i * 150);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 max-w-[1450px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            Kako poručiti?
          </h2>
          <p className="reveal opacity-0 translate-y-4 transition-all duration-700 delay-100 ease-out text-base text-foreground-700 max-w-2xl mx-auto">
            Tri jednostavna koraka do vašeg personalizovanog kućnog broja.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={step.number}
              className="reveal opacity-0 translate-y-4 transition-all duration-700 ease-out text-center"
              style={{ transitionDelay: `${(index + 2) * 150}ms` }}
            >
              <div className="relative mb-6 rounded-xl overflow-hidden border border-background-200">
                <img
                  src={step.image}
                  alt={step.title}
                  className="w-full h-48 md:h-52 object-cover"
                />
                <div className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-foreground-950 text-white rounded-full text-xs font-label font-bold">
                  {step.number}
                </div>
              </div>
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">{step.title}</h3>
              <p className="text-sm text-foreground-700 leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .reveal.animate-in {
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
    </section>
  );
}